import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromTaxes from './+state/taxes.reducer'
import { TaxesEffects } from './+state/taxes.effects'
import { TaxesFacade } from './+state/taxes.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTaxes.TAXES_FEATURE_KEY, fromTaxes.taxesReducer),
    EffectsModule.forFeature([TaxesEffects]),
  ],
  providers: [TaxesFacade],
})
export class GbDashboardSetupDataAccessTaxesModule {}
